module.exports = __webpack_public_path__ + "static/media/wheel.e88d76cf.svg";